import encUtf8 from 'crypto-js/enc-utf8'
import encBase64 from 'crypto-js/enc-base64'
import MD5 from 'crypto-js/md5'
import AES from 'crypto-js/aes'
import pkcs7 from 'crypto-js/pad-pkcs7'

const secureKey = 'AGS1WIG!IE*IQ9UW'
const finalKey = 'P)KSU0JNU&D=&^Dy'

/**
 * 1-手机 2-邮箱
 */
export enum loginTypes {
  phone = 1,
  email = 2
}
/**
 * 登录参数签名
 * @param payload
 * @param publicKey
 * @returns
 */
export const signLoginParams = async (
  payload: Record<string, any>,
  publicKey: string,
  loginType: loginTypes = loginTypes.email
) => {
  let encryptStr: string
  let md5password: any
  let captcha: any
  if (loginType === loginTypes.email) {
    const { userName, password } = payload
    md5password = MD5(password).toString()
    encryptStr = `USERLOGIN_KEY|${userName}|${loginTypes.email}|${md5password}`
  }
  if (loginType === loginTypes.phone) {
    const { userName } = payload
    captcha = payload.captcha
    encryptStr = `USERLOGIN_KEY|${userName}|${loginTypes.phone}|${captcha}`
  }

  const key = encUtf8.parse(finalKey)
  const iv = encUtf8.parse(secureKey)
  const aesEncryptResult = AES.encrypt(encryptStr, key, {
    iv,
    padding: pkcs7
  })
  const aesStr = aesEncryptResult.ciphertext
  const aesbase64 = encBase64.stringify(aesStr)
  const { JSEncrypt } = await import('jsencrypt')
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  const rsaEncrypt = encrypt.encrypt(aesbase64)
  const param = {
    ...payload,
    loginType,
    encryptModel: {
      secureKey,
      finalKey,
      encryption: rsaEncrypt
    }
  }
  if (loginType === loginTypes.email) {
    Object.assign(param, { password: md5password })
  }
  return param
}
